/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { useTranslation } from "react-i18next";
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { TemporalSelectorModes } from "../../layouts/TemporalSelector/TemporalSelector";
import CustomTooltip from "./CustomTooltip";
import DashboardChartWrapper from "./dashboardChartWrapper.component";
import { DashboardDailyData } from "./DashboardComponent";
import DashboarcComponentTitle from "./DashboardComponentTitle";

export interface DailyAggregateData {
	date: string;
	dateDay: string;
	document_total: number;
	document_total_compare?: number;
	document_num: number;
	document_num_compare?: number;
	document_avg: number;
	document_avg_compare?: number;
	cover_num: number;
	cover_num_compare?: number;
	cover_total_amount: number;
	cover_avg: number;
	bar_avg: number;
}

export interface IDashboardDailySellsProps {
	data: DashboardDailyData;
	reportCaption: string;
}

export interface IDashboardDailyProps {
	compareLegendLabel: string;
	mode: TemporalSelectorModes;
	responsiveContainerClassName: string;
}

const DashboardDailySells: React.FC<IDashboardDailySellsProps & IDashboardDailyProps> = (props) => {
	const { t } = useTranslation();

	const document_total_translated = t("zreports.zreport.totalDocumentAmount");

	const title = props.mode === TemporalSelectorModes.week ? t("dashboard.titles.weekly.total_documents") : t("dashboard.titles.monthly.total_documents");

	return (
		<DashboardChartWrapper>
			<DashboarcComponentTitle title={title} />
			<ResponsiveContainer height={160} className={props.responsiveContainerClassName}>
				<LineChart data={props.data.aggregates} margin={{ left: -20, top: 10 }}>
					<CartesianGrid />

					<XAxis dataKey="dateDay" />
					<Tooltip
						content={({ payload, label, active }: { payload: DailyAggregateData; label: string; active: boolean }) => (
							<CustomTooltip
								payload={payload}
								label={label}
								active={active}
								colorCurrent="#8884d8"
								colorPrevious="#888412"
								payloadCurrentKey={"document_total"}
								payloadPreviousKey={"document_total_compare"}
								mode={props.mode}
							/>
						)}
					/>
					<YAxis tick={{ fontSize: 18 }} />
					<Line
						animationDuration={2000}
						name={t("shared.period").toString()}
						type="monotone"
						dataKey="document_total"
						strokeWidth={2}
						stroke="#8884d8"
						activeDot={{ r: 8 }}
					/>
					<Line
						animationDuration={2000}
						name={t(props.compareLegendLabel).toString()}
						type="monotone"
						dataKey="document_total_compare"
						strokeWidth={1}
						stroke="#888412"
					/>
				</LineChart>
			</ResponsiveContainer>
		</DashboardChartWrapper>
	);
};

export default DashboardDailySells;
